// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulse-live {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.85);
  }
}
.live-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  animation: pulse-live 1.5s ease-in-out infinite;
  flex-shrink: 0;
}

.live-ring {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(34, 197, 94, 0.15);
  flex-shrink: 0;
}

.kpi-card {
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}
.kpi-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
}
.kpi-card.kpi-temp::before {
  background: linear-gradient(90deg, #ef4444, #f97316);
}
.kpi-card.kpi-voltage::before {
  background: linear-gradient(90deg, #3b82f6, #6366f1);
}
.kpi-card.kpi-current::before {
  background: linear-gradient(90deg, #22c55e, #10b981);
}
.kpi-card.kpi-power::before {
  background: linear-gradient(90deg, #f97316, #f59e0b);
}
.kpi-card.kpi-devices::before {
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
}
.kpi-card.kpi-oper::before {
  background: linear-gradient(90deg, #14b8a6, #06b6d4);
}

.evg-card {
  border-left-width: 4px !important;
  border-left-style: solid !important;
  transition: box-shadow 0.2s ease, transform 0.15s ease;
}
.evg-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.pwm-bar-track {
  height: 4px;
  background: #e5e7eb;
  border-radius: 9999px;
  overflow: hidden;
  margin-top: 4px;
}

.pwm-bar-fill {
  height: 100%;
  border-radius: 9999px;
  background: linear-gradient(90deg, #f97316, #f59e0b);
  transition: width 0.6s ease;
}

@keyframes lamp-glow {
  0%, 100% {
    filter: drop-shadow(0 0 3px #fbbf24);
  }
  50% {
    filter: drop-shadow(0 0 8px #f59e0b) brightness(1.15);
  }
}
.lamp-active {
  animation: lamp-glow 2s ease-in-out infinite;
  color: #f59e0b !important;
}

.lamp-off {
  color: #d1d5db !important;
  opacity: 0.6;
}

button.time-range-active {
  background: #fff;
  color: #2563eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.offline-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
  flex-shrink: 0;
}

.chart-stats-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0 20px;
  padding: 5px 10px;
  margin-bottom: 6px;
  background: rgba(248, 250, 252, 0.9);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 11px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.stat-param {
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-min {
  color: #3b82f6;
  font-weight: 600;
}

.stat-max {
  color: #ef4444;
  font-weight: 600;
}

.stat-avg {
  color: #8b5cf6;
  font-weight: 600;
}

.stat-sep {
  color: #cbd5e1;
}

@keyframes tt-fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.tt-hidden {
  display: none !important;
}

.chart-tooltip {
  position: fixed; /* viewport-level: never clipped by any parent overflow */
  z-index: 9999;
  pointer-events: none;
  background: rgba(15, 23, 42, 0.97);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 8px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 0;
  animation: tt-fade-in 120ms ease;
}
.chart-tooltip.repositioning {
  transition: left 80ms ease, top 80ms ease;
}

.tt-cards-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.tt-time {
  font-size: 10px;
  color: rgba(148, 163, 184, 0.9);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  margin-bottom: 2px;
}

.tt-card {
  border-left: 3px solid;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  padding: 5px 8px;
  width: 200px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.tt-card-header {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.tt-evg-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.tt-trend {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}
.tt-trend.tt-trend--up {
  color: #10b981;
}
.tt-trend.tt-trend--down {
  color: #ef4444;
}
.tt-trend.tt-trend--stable {
  color: #94a3b8;
}

.tt-badge {
  font-size: 9px;
  font-weight: 700;
  padding: 1px 4px;
  border-radius: 3px;
  letter-spacing: 0.03em;
}
.tt-badge.tt-badge--error {
  background: #ef4444;
  color: #fff;
}
.tt-badge.tt-badge--warn {
  background: #f59e0b;
  color: #fff;
}

.tt-values {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2px 8px;
}

.tt-val {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tt-val-key {
  font-size: 9px;
  color: rgba(148, 163, 184, 0.6);
  font-weight: 600;
  min-width: 10px;
}

.tt-val-num {
  font-size: 11px;
  color: #f1f5f9;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.lt-quick-btn {
  font-size: 11px;
  padding: 3px 9px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
}
.lt-quick-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}
.lt-quick-btn.lt-quick-all {
  border-color: #6366f1;
  color: #6366f1;
}
.lt-quick-btn.lt-quick-all:hover {
  background: #eef2ff;
}

.is-offline .kpi-card,
.is-offline .evg-card {
  opacity: 0.55;
  filter: grayscale(0.5);
  pointer-events: none;
}
.is-offline .lamp-active {
  animation: none !important;
  color: #9ca3af !important;
  filter: none !important;
}
.is-offline .pwm-bar-fill {
  background: #9ca3af !important;
  transition: none;
}`, "",{"version":3,"sources":["webpack://./src/app/features/live-data/live-data.scss"],"names":[],"mappings":"AACA;EACE;IAAW,UAAA;IAAY,mBAAA;EAEvB;EADA;IAAM,YAAA;IAAc,sBAAA;EAKpB;AACF;AAHA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,cAAA;AAKF;;AAFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;AAKF;;AADA;EACE,kBAAA;EACA,gBAAA;EACA,qDAAA;AAIF;AAFE;EACE,2BAAA;EACA,yCAAA;AAIJ;AADE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAGJ;AAAE;EAAyB,oDAAA;AAG3B;AAFE;EAAyB,oDAAA;AAK3B;AAJE;EAAyB,oDAAA;AAO3B;AANE;EAAyB,oDAAA;AAS3B;AARE;EAAyB,oDAAA;AAW3B;AAVE;EAAyB,oDAAA;AAa3B;;AATA;EACE,iCAAA;EACA,mCAAA;EACA,sDAAA;AAYF;AAVE;EACE,2BAAA;EACA,0CAAA;AAYJ;;AAPA;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAUF;;AAPA;EACE,YAAA;EACA,qBAAA;EACA,oDAAA;EACA,2BAAA;AAUF;;AANA;EACE;IAAW,oCAAA;EAUX;EATA;IAAY,qDAAA;EAYZ;AACF;AAVA;EACE,4CAAA;EACA,yBAAA;AAYF;;AATA;EACE,yBAAA;EACA,YAAA;AAYF;;AARA;EACE,gBAAA;EACA,cAAA;EACA,yCAAA;AAWF;;AAPA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAUF;;AANA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AASF;;AANA;EAAc,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAa3E;;AAZA;EAAc,cAAA;EAAgB,gBAAA;AAiB9B;;AAhBA;EAAc,cAAA;EAAgB,gBAAA;AAqB9B;;AApBA;EAAc,cAAA;EAAgB,gBAAA;AAyB9B;;AAxBA;EAAc,cAAA;AA4Bd;;AAzBA;EACE;IAAO,UAAA;IAAY,0BAAA;EA8BnB;EA7BA;IAAO,UAAA;IAAY,wBAAA;EAiCnB;AACF;AA/BA;EAAa,wBAAA;AAkCb;;AAhCA;EACE,eAAA,EAAA,yDAAA;EACA,aAAA;EACA,oBAAA;EACA,kCAAA;EACA,0BAAA;EACA,kCAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,gCAAA;AAmCF;AAjCE;EAAkB,yCAAA;AAoCpB;;AAhCA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;AAmCF;;AAhCA;EACE,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAmCF;;AAhCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAmCF;AAlCE;EAAoB,cAAA;AAqCtB;AApCE;EAAoB,cAAA;AAuCtB;AAtCE;EAAqB,cAAA;AAyCvB;;AAtCA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAyCF;AAxCE;EAAoB,mBAAA;EAAqB,WAAA;AA4C3C;AA3CE;EAAoB,mBAAA;EAAqB,WAAA;AA+C3C;;AA5CA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;AA+CF;;AA5CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA+CF;;AA5CA;EACE,cAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AA+CF;;AA5CA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;AA+CF;;AA3CA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6DAAA;EACA,mBAAA;AA8CF;AA5CE;EACE,mBAAA;EACA,qBAAA;AA8CJ;AA3CE;EACE,qBAAA;EACA,cAAA;AA6CJ;AA3CI;EAAU,mBAAA;AA8Cd;;AAxCE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AA2CJ;AAxCE;EACE,0BAAA;EACA,yBAAA;EACA,uBAAA;AA0CJ;AAvCE;EACE,8BAAA;EACA,gBAAA;AAyCJ","sourcesContent":["// ─── Live Pulse Indicator ───────────────────────────────────────────────────\n@keyframes pulse-live {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.4; transform: scale(0.85); }\n}\n\n.live-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #22c55e;\n  animation: pulse-live 1.5s ease-in-out infinite;\n  flex-shrink: 0;\n}\n\n.live-ring {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgba(34, 197, 94, 0.15);\n  flex-shrink: 0;\n}\n\n// ─── KPI Cards ──────────────────────────────────────────────────────────────\n.kpi-card {\n  position: relative;\n  overflow: hidden;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n  }\n\n  &.kpi-temp::before     { background: linear-gradient(90deg, #ef4444, #f97316); }\n  &.kpi-voltage::before  { background: linear-gradient(90deg, #3b82f6, #6366f1); }\n  &.kpi-current::before  { background: linear-gradient(90deg, #22c55e, #10b981); }\n  &.kpi-power::before    { background: linear-gradient(90deg, #f97316, #f59e0b); }\n  &.kpi-devices::before  { background: linear-gradient(90deg, #6366f1, #8b5cf6); }\n  &.kpi-oper::before     { background: linear-gradient(90deg, #14b8a6, #06b6d4); }\n}\n\n// ─── EVG Cards ──────────────────────────────────────────────────────────────\n.evg-card {\n  border-left-width: 4px !important;\n  border-left-style: solid !important;\n  transition: box-shadow 0.2s ease, transform 0.15s ease;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  }\n}\n\n// ─── PWM Progress Bar ───────────────────────────────────────────────────────\n.pwm-bar-track {\n  height: 4px;\n  background: #e5e7eb;\n  border-radius: 9999px;\n  overflow: hidden;\n  margin-top: 4px;\n}\n\n.pwm-bar-fill {\n  height: 100%;\n  border-radius: 9999px;\n  background: linear-gradient(90deg, #f97316, #f59e0b);\n  transition: width 0.6s ease;\n}\n\n// ─── Lamp Glow ──────────────────────────────────────────────────────────────\n@keyframes lamp-glow {\n  0%, 100% { filter: drop-shadow(0 0 3px #fbbf24); }\n  50%       { filter: drop-shadow(0 0 8px #f59e0b) brightness(1.15); }\n}\n\n.lamp-active {\n  animation: lamp-glow 2s ease-in-out infinite;\n  color: #f59e0b !important;\n}\n\n.lamp-off {\n  color: #d1d5db !important;\n  opacity: 0.6;\n}\n\n// ─── Time range segmented control ───────────────────────────────────────────\nbutton.time-range-active {\n  background: #fff;\n  color: #2563eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\n// ─── Offline indicator ───────────────────────────────────────────────────────\n.offline-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #ef4444;\n  flex-shrink: 0;\n}\n\n// ─── Stats Bar ───────────────────────────────────────────────────────────────\n.chart-stats-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 20px;\n  padding: 5px 10px;\n  margin-bottom: 6px;\n  background: rgba(248, 250, 252, 0.9);\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 11px;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.stat-param { font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; }\n.stat-min   { color: #3b82f6; font-weight: 600; }\n.stat-max   { color: #ef4444; font-weight: 600; }\n.stat-avg   { color: #8b5cf6; font-weight: 600; }\n.stat-sep   { color: #cbd5e1; }\n\n// ─── Compact Chart Tooltip ────────────────────────────────────────────────────\n@keyframes tt-fade-in {\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.tt-hidden { display: none !important; }\n\n.chart-tooltip {\n  position: fixed;   /* viewport-level: never clipped by any parent overflow */\n  z-index: 9999;\n  pointer-events: none;\n  background: rgba(15, 23, 42, 0.97);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 8px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  animation: tt-fade-in 120ms ease;\n  // Smooth reposition — don't animate on first appear (animation handles that)\n  &.repositioning { transition: left 80ms ease, top 80ms ease; }\n}\n\n// Cards wrap horizontally: 1–3 side by side, then wrap to next row\n.tt-cards-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.tt-time {\n  font-size: 10px;\n  color: rgba(148, 163, 184, 0.9);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding-bottom: 4px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  margin-bottom: 2px;\n}\n\n.tt-card {\n  border-left: 3px solid;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 5px 8px;\n  width: 200px;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.tt-card-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.tt-evg-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.tt-trend {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  &.tt-trend--up    { color: #10b981; }\n  &.tt-trend--down  { color: #ef4444; }\n  &.tt-trend--stable { color: #94a3b8; }\n}\n\n.tt-badge {\n  font-size: 9px;\n  font-weight: 700;\n  padding: 1px 4px;\n  border-radius: 3px;\n  letter-spacing: 0.03em;\n  &.tt-badge--error { background: #ef4444; color: #fff; }\n  &.tt-badge--warn  { background: #f59e0b; color: #fff; }\n}\n\n.tt-values {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2px 8px;\n}\n\n.tt-val {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tt-val-key {\n  font-size: 9px;\n  color: rgba(148, 163, 184, 0.6);\n  font-weight: 600;\n  min-width: 10px;\n}\n\n.tt-val-num {\n  font-size: 11px;\n  color: #f1f5f9;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n// ─── Quick-select parameter buttons ─────────────────────────────────────────\n.lt-quick-btn {\n  font-size: 11px;\n  padding: 3px 9px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #374151;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n  white-space: nowrap;\n\n  &:hover {\n    background: #f3f4f6;\n    border-color: #d1d5db;\n  }\n\n  &.lt-quick-all {\n    border-color: #6366f1;\n    color: #6366f1;\n\n    &:hover { background: #eef2ff; }\n  }\n}\n\n// ─── Offline dim state ───────────────────────────────────────────────────────\n.is-offline {\n  .kpi-card,\n  .evg-card {\n    opacity: 0.55;\n    filter: grayscale(0.5);\n    pointer-events: none;\n  }\n\n  .lamp-active {\n    animation: none !important;\n    color: #9ca3af !important;\n    filter: none !important;\n  }\n\n  .pwm-bar-fill {\n    background: #9ca3af !important;\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
